module.exports = __webpack_public_path__ + "img/line-selected.bf402803.svg";